import * as React from 'react';
import { ISubMenuItem } from '../../../models/ISubMenuItem';
import device from '../../../services/mini/device';
import UserInfoPopupSubMenuItem from './UserInfoPopupSubMenuItem';

type UserInfoPopupSubMenuProps = {
    opened: boolean,
    items: ISubMenuItem[],
    selectedItemId: string,
    onSelect: (id: string) => void
}

class UserInfoPopupSubMenu extends React.Component<UserInfoPopupSubMenuProps> {
    select = (id) => {
        this.props.onSelect(id);
    }

    render() {
        const {
            opened,
            items,
            selectedItemId,
        } = this.props;

        return <div className={`user-info-popup-sub-menu ${opened && 'opened'} ${device.isMobile() && 'mobile'}`}>
            {items.map(item =>
                <UserInfoPopupSubMenuItem
                    key={item.id}
                    item={item}
                    selected={selectedItemId === item.id}
                    onSelect={this.select}
                />)}
        </div>;
    }
}
export default UserInfoPopupSubMenu;